import { Alpine } from '../../../vendor/livewire/livewire/dist/livewire.esm';

document.addEventListener('alpine:init', () => {
  Alpine.store('menu', {
    on: '',

    toggle(value: string) {
      this.on = value;
    },
  });
});
